export default __webpack_public_path__ + "static/media/VerifiedCarbon.c8a2182f.png";